var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLbrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h67.491v45H0V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20.452v20.46H0V0Z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40.86h67.491V45H0v-4.14Z",
    fill: "#C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40.904h67.491V45H0v-4.096Zm0-8.165h67.491v4.06H0v-4.06Zm0-8.191h67.324v4.104H0v-4.104ZM20.452 0h47.03v4.087h-47.03V0Zm0 16.348h47.03v4.113h-47.03v-4.113Zm0-8.148h47.03v4.087h-47.03V8.2Z",
    fill: "#C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.616 15.6-4.456-2.724-4.43 2.751 1.644-4.474-4.42-2.76 5.475-.035 1.696-4.456 1.74 4.448h5.476l-4.404 2.786 1.68 4.465Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbrFlag);
export default __webpack_public_path__ + "static/media/lbr-flag.744836ad040879cf018298325275e59c.svg";
export { ForwardRef as ReactComponent };